import { useState, useCallback } from 'react'
import { useQuery, useAction } from 'convex/react'
import { api } from '../../../../convex/_generated/api'

/**
 * Hook to get the count of pending changes since last deploy
 */
export function usePendingChanges() {
  const data = useQuery(api.deploy.getPendingChangesCount)

  return {
    count: data?.count ?? 0,
    lastDeployedAt: data?.lastDeployedAt ?? null,
    isLoading: data === undefined,
  }
}

/**
 * Hook to get the current deploy status
 */
export function useDeployStatus() {
  const data = useQuery(api.deploy.getDeployStatus)

  return {
    hasDeployed: data?.hasDeployed ?? false,
    lastDeployedAt: data?.lastDeployedAt ?? null,
    isLoading: data === undefined,
  }
}

/**
 * Hook to trigger a deploy to Cloudflare Pages
 */
export function useTriggerDeploy() {
  const triggerAction = useAction(api.deploy.triggerDeploy)
  const [isPending, setIsPending] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const trigger = useCallback(async () => {
    setIsPending(true)
    setError(null)
    try {
      await triggerAction()
    } catch (err) {
      const error = err instanceof Error ? err : new Error(String(err))
      setError(error)
      throw error
    } finally {
      setIsPending(false)
    }
  }, [triggerAction])

  return { trigger, isPending, error }
}
